import PropTypes from "prop-types";

const InfoItem = ({ label, value, valueClassName = "" }) => {
  if (!value) return null;

  return (
    <div className="flex justify-between items-center py-1 sm:py-1.5 gap-2 sm:gap-3">
      <span className="text-xs sm:text-sm font-medium" style={{ color: "#3B3B3B" }}>
        {label}
      </span>
      <span
        className={`text-xs sm:text-sm font-normal text-right ${valueClassName}`}
        style={{ color: "#515164" }}
      >
        {value}
      </span>
    </div>
  );
};

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueClassName: PropTypes.string,
};

export default InfoItem;
